import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { CarouselItem, I18n, UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';
import { PartialRecord } from '../Utils';

enum SpaceMembershipTierState {
  Available = 'available',
  WaitingToDisable = 'waitingToDisable',
  Disabled = 'disabled',
}

type MonthlySubscriptionPlan = {
  rewardOfferId?: Uuid;
  store?: 'joyajoy'; // string
  // price: number; // in cents
  // newPrice?: number; // in cents
  // willBeEffectiveAt?: T;
};

type MonthlySubscription<T> = {
  monthly: MonthlySubscriptionPlan;
  lastExpireAt?: T;
};

type YearlySubscriptionPlan = {
  rewardOfferId?: Uuid;
  store?: 'joyajoy'; // string
};

type YearlySubscription<T> = {
  yearly: YearlySubscriptionPlan;
  lastExpireAt?: T;
};

type PermanentSubscriptionPlan = {
  rewardOfferId?: Uuid;
  store?: string;
};

type PermanentSubscription = {
  permanent: PermanentSubscriptionPlan;
};

type SubscriptionType<T> =
  | MonthlySubscription<T>
  | YearlySubscription<T>
  | PermanentSubscription;

enum StatisticsKey {
  SubscriptionCount = 'subscriptionCount',
  MonthlySubscriptionCount = 'monthlySubscriptionCount',
  ActiveMonthlySubscriptionCount = 'activeMonthlySubscriptionCount',
  permanentSubscriptionCount = 'permanentSubscriptionCount',
  ActivePermanentSubscriptionCount = 'activePermanentSubscriptionCount',
  YearlySubscriptionCount = 'yearlySubscriptionCount',
  ActiveYearlySubscriptionCount = 'activeYearlySubscriptionCount',
}

type I18nClassroomMembershipTierInfo = I18n<{
  name: string;
  shortDescription: string | null;
  description: string | null;
  carousel: CarouselItem[];
}>;

export type SpaceMembershipTierJson<T = number> = {
  classroomId: Uuid;
  tierId: Uuid;
  createdBy: UserId;
  createdAt: T;
  lastModifiedAt: T;
  state: SpaceMembershipTierState;
  i18nClassroomMembershipTierInfo: I18nClassroomMembershipTierInfo;
  classroomCreditMultiplier: number; // double
  subscription?: SubscriptionType<T>;
  statistics: PartialRecord<StatisticsKey, number>;
};

export class SpaceMembershipTier
  extends RepositoryElement
  implements SpaceMembershipTierJson<Date>
{
  readonly tierId!: Uuid; //identifier
  readonly classroomId!: Uuid; //identifier
  createdBy!: UserId;
  createdAt!: Date;
  lastModifiedAt!: Date;
  state!: SpaceMembershipTierState;
  i18nClassroomMembershipTierInfo!: I18nClassroomMembershipTierInfo;
  classroomCreditMultiplier!: number;
  subscription!: SubscriptionType<Date>;
  statistics!: PartialRecord<StatisticsKey, number>;

  constructor(inventory: SpaceMembershipTierJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(inventory));
  }

  id(): string {
    return `${this.classroomId}_${this.tierId}`;
  }

  toJSON(): SpaceMembershipTierJson {
    return deepTransformDate(this) as unknown as SpaceMembershipTierJson;
  }
}
